import React from 'react';
import styled, { keyframes } from 'styled-components';
import { colors } from '../../styles/colors';

const gradientMove = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

const rotate = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const BuildersSection = styled.section`
  padding: 4rem 5%;
  background: ${colors.white};
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(
      45deg,
      ${colors.primary}05,
      ${colors.accent}05,
      ${colors.primary}05
    );
    animation: ${gradientMove} 15s ease infinite;
    transform: rotate(-45deg);
    z-index: 0;
  }
`;

const SectionTitle = styled.h2`
  text-align: center;
  color: ${colors.darkGrey};
  font-size: 2.5rem;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
  
  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 3px;
    background: ${colors.accent};
    margin: 1rem auto;
  }
`;

const BuildersContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 2rem;
  }
`;

const BuilderCard = styled.div`
  background: ${colors.white};
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at center, ${colors.accent}10, transparent);
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  
  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.1);
    
    &:before {
      opacity: 1;
    }
    
    img {
      transform: scale(1.05);
    }
  }
`;

const BuilderLogo = styled.img`
  max-width: 300px;
  height: auto;
  transition: transform 0.3s ease;
  
  @media (max-width: 768px) {
    max-width: 250px;
  }
`;

const Divider = styled.div`
  width: 2px;
  height: 100px;
  background: ${colors.accent};
  opacity: 0.5;
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: ${colors.accent};
    border-radius: 50%;
    top: -5px;
    left: -4px;
    animation: ${rotate} 3s linear infinite;
  }
  
  &:after {
    content: '';
    position: absolute;
    width: 10px;
    height: 10px;
    background: ${colors.accent};
    border-radius: 50%;
    bottom: -5px;
    left: -4px;
    animation: ${rotate} 3s linear infinite reverse;
  }
  
  @media (max-width: 768px) {
    width: 100px;
    height: 2px;
    
    &:before, &:after {
      top: -4px;
      bottom: auto;
    }
    
    &:before {
      left: -5px;
    }
    
    &:after {
      left: auto;
      right: -5px;
    }
  }
`;

const Builders = () => {
  return (
    <BuildersSection id="builders">
      <SectionTitle>A PROJECT BY</SectionTitle>
      <BuildersContainer>
        <BuilderCard>
          <BuilderLogo
            src={process.env.PUBLIC_URL + '/images/rudani-logo.png'}
            alt="Rudani Realty"
          />
        </BuilderCard>
        <Divider />
        <BuilderCard>
          <BuilderLogo
            src={process.env.PUBLIC_URL + '/images/shreejee-logo.png'}
            alt="Shreejee Buildcon Group"
          />
        </BuilderCard>
      </BuildersContainer>
    </BuildersSection>
  );
};

export default Builders; 